import * as React from "react";
const SvgHoles = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 23 23",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "holes_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "holes_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M11.5 0A11.5 11.5 0 1 0 23 11.5 11.51 11.51 0 0 0 11.5 0m0 21a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.75 8a3.5 3.5 0 1 0 3.5 3.5A3.5 3.5 0 0 0 7.75 8m0 5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5M15.75 8a3.5 3.5 0 1 0 3.5 3.5 3.5 3.5 0 0 0-3.5-3.5m0 5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5",
	style: { fill: "currentColor" }
}))));
export default SvgHoles;
